import { render, staticRenderFns } from "./teachingPoint.vue?vue&type=template&id=94dbf5fc&scoped=true&"
import script from "./teachingPoint.vue?vue&type=script&lang=js&"
export * from "./teachingPoint.vue?vue&type=script&lang=js&"
import style0 from "./teachingPoint.vue?vue&type=style&index=0&id=94dbf5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dbf5fc",
  null
  
)

export default component.exports